import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { GlobalQrComponent } from '../global-qr/global-qr.component';
import { PRIMENG_MODULES } from '@shared/primeng';
import { Router } from '@angular/router';

@Component({
	selector: 'app-global-toolbar',
	imports: [CommonModule, GlobalQrComponent, ...PRIMENG_MODULES],
	templateUrl: './global-toolbar.component.html',
	styleUrl: './global-toolbar.component.scss',
})
export class GlobalToolbarComponent {
	private readonly router = inject(Router);

	goToCapyIA(): void {
		if (this.router.url === '/capy-ia') {
			return;
		}

		this.router.navigate(['/capy-ia']);
	}
}
